import { MobiDocument } from './MobiDocument';

export class AllergieDocument extends MobiDocument{
    private _id : string;
    private _rev : string;
    private id : number;
    private libelle: string;
    private allergiqueA: string;


    public constructor(allergie : any){
        super()
        this._id = allergie._id;
        this._rev = allergie._rev;
        this.id = allergie.id;
        this.libelle = allergie.libelle;
        this.allergiqueA = "";
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getLibelle(): string {
        return this.libelle;
    }

    public setLibelle(libelle: string): void {
        this.libelle = libelle;
    }

    public getAllergiqueA(): string {
        return this.allergiqueA;
    }

    public setAllergiqueA(allergiqueA: string): void {
        this.allergiqueA = allergiqueA;
    }
}